<template>
  <tr>
    <th>
      <label class="date" :for="datepickerId">{{label}}</label>
    </th>
    <td class="date">
      <b-form-datepicker
        :id="datepickerId"
        v-model="dateStr"
        :min="min"
        :start-weekday="MONDAY"
      />
    </td>
    <td width="25%">
      <time-input v-model="timeStr"/>
    </td>
  </tr>
</template>

<script>
import { convertMomentToDataStr              } from '../../util.js';
import { convertMomentToTimeStr              } from '../../util.js';
import { convertDataStrAndTimeStrToLocalData } from '../../util.js';

import TimeInput from '../TimeInput.vue';

let lastComponentId = 0;

export default {
  name: 'MomentInputTr',

  components: {
    TimeInput
  },

  props: {
    label: {
      type: String,
      required: true,
    },

    // Date or String
    min: {},

    value: {
      type: Date,
      required: true,
    },
  },

  data() {    
    lastComponentId++;
    const curComponentId = lastComponentId;

    const moment = this.value;
    const timeStr = convertMomentToTimeStr(moment);
    const dateStr = convertMomentToDataStr(moment);

    return {
      MONDAY: 1,

      dateStr: dateStr,
      timeStr: timeStr,

      datepickerId: 'MomentInputTrDatepickerId' + curComponentId.toString(),
    };
  },

  computed: {
    /** @returns {?Date} */
    moment() {
      return convertDataStrAndTimeStrToLocalData(this.dateStr, this.timeStr);
    },
  },

  watch: {
    dateStr() {
      this.emitInput();
    },

    timeStr() {
      this.emitInput();
    }
  },

  methods: {
    emitInput() {
      this.$emit('input', this.moment);
    }
  }
};
</script>

<style scoped>
label.date {
  margin-bottom: 0;
}

th {
  width: 0%;
  padding-right: .5rem;
}

td.date {
  padding-right: .2rem;
}
</style>
